import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const getPushUpsAvailabilityRequest = createAction("".concat(stateName, "/getPushUpsAvailabilityRequest"));
export const getPushUpsAvailabilityFailure = createAction("".concat(stateName, "/getPushUpsAvailabilityFailure"));
export const startCheckout = createAction("".concat(stateName, "/startCheckout"));